import React, { createContext, useContext, useState } from 'react';

const UserContext = createContext();

export const useUser = () => useContext(UserContext);

export const UserProvider = ({ children }) => {
  const [userData, setUserData] = useState({
    name: '',
    surname: '',
    email: '',
    transaction_id: '',
    payment_string: '',
    // One-shot notice raised at signup and shown on the next page, which is why
    // it cannot be a toast on the signup page itself: that page navigates away
    // the moment the account is created, unmounting its toast container.
    signupNotice: '',
  });

  return (
    <UserContext.Provider value={{ userData, setUserData }}>
      {children}
    </UserContext.Provider>
  );
};
